export function createDiv(id) {
  id = id || String(Date.now())
  const div = document.createElement('div')
  div.id = id
  document.body.appendChild(div)
  return [div, id]
}
